import React, { Component } from "react";
import { Column, Table } from "react-virtualized";
import { AutoSizer } from "react-virtualized";

// Countries loaded from: https://stefangabos.github.io/world_countries/
import countries from '../../i18n/el/world.el.json';
import { Link, withRouter } from "react-router-dom";

const countryName = (countryCode) => {
  let code = countryCode.toLowerCase();
  let country = countries.find(country => {
    return country.alpha2 === code;
  });
  return country.name;
}

function headerRowRenderer({ className, columns, style }) {
  let headerRowStyle = {
    ...style,
    display: 'flex'
  }
  return (
    <div className={className} role="row" style={headerRowStyle}>
      {columns}
    </div>
  );
}

function rowRenderer(
  {
    className, columns, index, key, onRowClick, onRowDoubleClick,
    onRowMouseOut, onRowMouseOver, onRowRightClick, rowData, style,
  }) {
  const a11yProps = {'aria-rowindex': index + 1};

  if (
    onRowClick ||
    onRowDoubleClick ||
    onRowMouseOut ||
    onRowMouseOver ||
    onRowRightClick
  ) {
    a11yProps['aria-label'] = 'row';
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = event => onRowClick({event, index, rowData});
    }
    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = event =>
        onRowDoubleClick({event, index, rowData});
    }
    if (onRowMouseOut) {
      a11yProps.onMouseOut = event => onRowMouseOut({event, index, rowData});
    }
    if (onRowMouseOver) {
      a11yProps.onMouseOver = event => onRowMouseOver({event, index, rowData});
    }
    if (onRowRightClick) {
      a11yProps.onContextMenu = event =>
        onRowRightClick({event, index, rowData});
    }
  }

  let rowStyle = {
    ...style,
    display: 'flex'
  }
  return (
    <div
      {...a11yProps}
      className={className}
      key={key}
      role="row"
      style={rowStyle}>
      {columns}
    </div>
  );
}

function noRowsRenderer() {
  return <div id={'table-no-rows-notice'} style={{textAlign: 'center'}}>No applications found</div>
}

function headerRenderer(
  {
    columnData, dataKey, disableSort,
    label, sortBy, sortDirection
  }
) {
  return (
    <React.Fragment key={dataKey}>
      <div className="ReactVirtualized__Table__headerTruncatedText" style={{borderBottom: '1px solid #858796'}}>
        {label}
      </div>
    </React.Fragment>
  );
}

function nameCellRenderer(p) {
  let value = '';
  if (p.rowData.firstName != null) {
    value = p.rowData.firstName;
  }

  if (p.rowData.lastName != null) {
    if (value.length > 0) {
      value += ' ';
    }

    value += p.rowData.lastName;
  }

  return value;
}

function educationCellRenderer(p) {
  if (p.rowData.lineOfEducationId === '00000000-0000-0000-0000-000000000000') {
    return p.rowData.otherLineOfEducation;
  } else {
    let lineOfEducation =
      p.columnData.linesOfEducation
        .find(lineOfEducation => lineOfEducation.lineOfEducationId === p.rowData.lineOfEducationId)
    if (lineOfEducation === undefined) {
      return "Άγνωστο Αντικείμενο";
    }

    lineOfEducation = lineOfEducation.title["el"];
    if (lineOfEducation === undefined) {
      return "Άγνωστο Αντικείμενο";
    }

    return lineOfEducation;
  }
}

function countryCellRenderer(p) {
  if (p.cellData == null) {
    return '';
  } else {
    return String(countryName(p.cellData));
  }
}

function actionsHeaderRenderer(
  {
    columnData, dataKey, disableSort, label, sortBy, sortDirection
  }) {
  return <React.Fragment key={dataKey}>
    <div className="ReactVirtualized__Table__headerTruncatedText" style={{borderBottom: '1px solid #858796'}}>
      {label}
    </div>
  </React.Fragment>
}

function actionsCellRenderer(p) {
  let history = p.columnData.history;
  let data = p.rowData

  function handleClick(event) {
    event.preventDefault();
    history.push('/volunteer-applications/' + data.applicationId);
  }

  if (p.cellData == null) {
    return <Link id={'action-load-' + data.applicationId} to={'/volunteer-applications/' + data.applicationId} onClick={handleClick}><i className={"fas fa-chevron-right"} style={{color: '#858796'}}/></Link>
  } else {
    return String(p.cellData);
  }
}

class VolunteerApplicationTable extends Component {
  state = {
    widths: {
      name: 0.3,
      otherLineOfEducation: 0.2,
      city: 0.2,
      country: 0.2,
      actions: 0.1
    }
  }

  render() {
    const { applications, linesOfEducation } = this.props;
    const { widths } = this.state;

    return (
      <AutoSizer>
        {({ height, width }) => (
          <Table id={"volunteer-applications-table"}
                 width={width}
                 height={height}
                 headerHeight={30}
                 headerRowRenderer={headerRowRenderer}
                 rowHeight={30}
                 rowCount={applications.length}
                 rowGetter={({ index }) => applications[index]}
                 rowRenderer={rowRenderer}
                 noRowsRenderer={noRowsRenderer}>
            <Column
              id='full-name'
              headerRenderer={headerRenderer}
              dataKey="name"
              label="Όνοματεπώνυμο"
              cellRenderer={nameCellRenderer}
              width={widths.name * width}
              style={{
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                paddingLeft: "3px",
                paddingRight: "3px"
              }}
            />
            <Column
              id='line-of-education'
              headerRenderer={headerRenderer}
              dataKey="otherLineOfEducation"
              label="Πεδίο Εκπαίδευσης"
              width={widths.otherLineOfEducation * width}
              cellRenderer={educationCellRenderer}
              columnData={{
                linesOfEducation: linesOfEducation
              }}
              style={{
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                paddingLeft: "3px",
                paddingRight: "3px"
              }}
            />
            <Column
              id='city'
              headerRenderer={headerRenderer}
              dataKey="city"
              label="Πόλη"
              width={widths.city * width}
              style={{
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                paddingLeft: "3px",
                paddingRight: "3px"
              }}
            />
            <Column
              id='country'
              headerRenderer={headerRenderer}
              dataKey="country"
              label="Χώρα"
              cellRenderer={countryCellRenderer}
              width={widths.country * width}
              style={{
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                paddingLeft: "3px",
                paddingRight: "3px"
              }}
            />
            <Column
              id='actions'
              dataKey={"actions"}
              label={"Ενέργειες"}
              headerRenderer={actionsHeaderRenderer}
              headerStyle={{
                textAlign: 'center'
              }}
              columnData={{
                history: this.props.history
              }}
              cellRenderer={actionsCellRenderer}
              width={widths.actions * width}
              style={{
                textAlign: 'center'
              }}
            />
          </Table>
        )}
      </AutoSizer>
    )
  }
}

export default withRouter(VolunteerApplicationTable);